// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  dialog: {
    '& .MuiDialog-paper': {
      width: '30rem',
    },
  },
  titleSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2, 3),
  },
  dialogTitle: {
    fontWeight: 600,
    fontSize: '20px',
    padding: 0,
    textTransform: 'none',
  },
  dialogContent: {
    padding: theme.spacing(2, 3),
    paddingTop: 0,
  },
  dialogText: {
    marginBottom: theme.spacing(2),
  },
  folderListContainer: {
    maxHeight: '14.5rem',
    height: '14.5rem',
    overflowY: 'auto',
  },
  folderItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: theme.spacing(1, 0),
    padding: theme.spacing(1, 2),
    height: '3rem',
    '& .moveButton': {
      display: 'none',
    },
    '&:hover': {
      backgroundColor: '#F0F0F5',
      '& .moveButton': {
        display: 'block',
      },
    },
  },
  folderIcon: {
    marginRight: theme.spacing(1),
  },
  folderName: {
    textTransform: 'none',
  },
  folderDetails: {
    display: 'flex',
    alignItems: 'center',
  },
  moveButton: {
    display: 'none',
    '&:hover': {
      display: 'block',
    },
  },
  buttonProgress: {
    color: '#777777',
  },
  noFoldersContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  noFoldersIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '50px',
    width: '50px',
    borderRadius: '50%',
    backgroundColor: '#E5EAEE',
  },
  noFoldersText: {
    marginTop: theme.spacing(1),
    textTransform: 'none',
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    marginTop: theme.spacing(2),
  },
  unassignDivider: {
    margin: theme.spacing(1, 0),
  },
});

export default styles;
